import axios from 'axios';
import { ClientError } from './errors.js';
/**
 * Owner Olympus client
 */
class ClientInstance {
    instance;
    constructor(baseURL, getRequestSettings, { defaultHeaders, onRequestError, onResponseError, formatRequest, formatResponse, timeout, } = {}) {
        const headers = {
            Accept: 'application/json',
            ...defaultHeaders,
        };
        this.instance = axios.create({
            baseURL,
            headers,
            withCredentials: true,
        });
        if (timeout) {
            this.instance.defaults.timeout = timeout;
        }
        this.instance.interceptors.request.use(async (req) => {
            const { audience, client, csrfToken, activeBrandId, bearerToken } = await getRequestSettings();
            if (audience) {
                req.headers['X-PB-Audience'] =
                    req.headers?.['X-PB-Audience'] ?? audience;
            }
            if (client) {
                req.headers['X-PB-Client'] = req.headers?.['X-PB-Client'] ?? client;
            }
            if (csrfToken) {
                req.headers['X-CSRFToken'] = req.headers?.['X-CSRFToken'] ?? csrfToken;
            }
            if (bearerToken) {
                req.headers.authorization = req.headers?.Authorization
                    ? [`Bearer ${bearerToken}`, req.headers?.Authorization].join(', ')
                    : `Bearer ${bearerToken}`;
            }
            if (activeBrandId) {
                req.headers['X-Active-Brand-ID'] =
                    req.headers?.['X-Active-Brand-ID'] ?? activeBrandId;
            }
            if (formatRequest)
                req = await formatRequest(req);
            return req;
        }, onRequestError);
        if (formatResponse || onResponseError)
            this.instance.interceptors.response.use(formatResponse, onResponseError);
    }
    async exec(method, path, req, knownErrors) {
        try {
            const { data } = await this.send(method, path, req);
            return data;
        }
        catch (error) {
            if (axios.isAxiosError(error) &&
                knownErrors.includes(error.response?.data.code)) {
                const { code, message, status, payload } = error.response?.data;
                throw new ClientError(code, message, status, payload);
            }
            throw error;
        }
    }
    async send(method, basePath, req) {
        const options = {
            headers: req.headers,
        };
        if (req.query && Object.keys(req.query).length) {
            options.params = req.query;
        }
        const path = this.formatPath(basePath, req);
        switch (method) {
            case 'DELETE':
                return await this.instance.delete(path, options);
            case 'GET':
                return await this.instance.get(path, options);
            case 'PATCH':
                return await this.instance.patch(path, req.body, options);
            case 'POST':
                return await this.instance.post(path, req.body, options);
            case 'PUT':
                return await this.instance.put(path, req.body, options);
        }
    }
    formatPath(path, request) {
        for (const [key, value] of Object.entries(request.params ?? {})) {
            path = path.replace(`{${key}}`, value);
        }
        return path;
    }
}
export default ClientInstance;
//# sourceMappingURL=instance.js.map